/**
 * Frontend marketplace registries — populated only via app register(app).
 */
const pageLoaders = new Map(); // `${appCode}:${pageKey}` -> () => import(...)
const slotComponents = new Map(); // componentKey -> () => import(...)
const manifests = new Map();

export const registries = {
  pageLoaders,
  slotComponents,
  manifests,
};

export const resetRegistriesForTests = () => {
  pageLoaders.clear();
  slotComponents.clear();
  manifests.clear();
};
